export enum MessageResponseTypes {
    MailStartupData = 'MailStartupData',
    MailSessionData = 'MailSessionData',
    PushSubscriptionData = 'PushSubscriptionData',
    DeviceGUID = 'DeviceGUID',
    UnsubscribeOwaPush = 'UnsubscribeOwaPush',
    ScreenShot = 'screenshot',
}
